import React from "react";

const Eye = () => (
  <svg width="15" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity=".5" fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M14.97 5.33A8.345 8.345 0 007.5 0 8.345 8.345 0 00.03 5.33a.5.5 0 000 .34A8.345 8.345 0 007.5 11a8.345 8.345 0 007.47-5.33.5.5 0 000-.34zM4.54 5.6a3 3 0 116 0 3 3 0 01-6 0zm1 0a2 2 0 104 0 2 2 0 00-4 0zm-4.505-.1C2.05 8.035 4.85 10 7.5 10s5.45-1.965 6.465-4.5C12.95 2.965 10.15 1 7.5 1S2.05 2.965 1.035 5.5z" />
  </svg>
);

export default Eye;
